import { DEMO_PEOPLE } from '@/lib/demo/people'
import { MACHINES } from '@/features/actions/demo/catalog'
import {
  SLOT_MINUTES,
  addDays,
  fromMinutes,
  oneHourAfter,
  today,
} from '@/features/scheduler/schedulerDates'
import type { Appointment, Device } from '@/features/scheduler/types'

const NAMES = DEMO_PEOPLE

export const DEVICES: Device[] = MACHINES.map((name, index) => ({
  id: String(index + 1),
  name,
  position: index + 1,
}))

const STATUS_LABELS: Record<string, string> = {
  booked: 'Gebucht',
  checked_in: 'Eingecheckt',
  done: 'Erledigt',
  cancelled: 'Storniert',
  no_show: 'Nicht erschienen',
}

const KIND_LABELS: Record<string, string> = {
  trial: 'Probetermin',
  treatment: 'Behandlungstermin',
}

const CREDIT_LABELS: Record<string, string> = {
  consumed: 'Verbraucht',
  reserved: 'Reserviert',
  open: 'Offen',
}
const SEED_RANGE = 14

function statusFor(offset: number, slot: number): string {
  if (offset > 0) return slot % 7 === 3 ? 'cancelled' : 'booked'
  if (offset === 0) return slot % 4 === 1 ? 'checked_in' : 'booked'
  if (slot % 6 === 4) return 'no_show'
  if (slot % 6 === 5) return 'cancelled'
  return 'done'
}

export function seedAppointments(): Appointment[] {
  const base = today()
  const appointments: Appointment[] = []
  let counter = 0

  for (let offset = -SEED_RANGE; offset <= SEED_RANGE; offset++) {
    const date = addDays(base, offset)
    // Sundays are closed, Saturdays quiet.
    const weekday = new Date(`${date}T12:00:00`).getDay()
    if (weekday === 0) continue

    const perDay = weekday === 6 ? 3 : 5 + (Math.abs(offset) % 3)

    for (let slot = 0; slot < perDay; slot++) {
      const step = counter++
      const hour = 8 + ((slot * 2 + offset + 14) % 11)
      const quarter = ((((offset + (slot % MACHINES.length)) % 4) + 4) % 4) * SLOT_MINUTES
      const start = fromMinutes(hour * 60 + quarter)

      const status = statusFor(offset, slot)
      const kind = step % 11 === 0 ? 'trial' : 'treatment'
      const creditState = status === 'checked_in' ? 'consumed' : 'reserved'

      appointments.push({
        id: `3${String(step).padStart(3, '0')}`,
        deviceId: DEVICES[slot % DEVICES.length].id,
        deviceName: DEVICES[slot % DEVICES.length].name,
        customerId: String(500 + (step % NAMES.length)),
        customerName: NAMES[step % NAMES.length],
        date,
        start,
        end: oneHourAfter(start),
        kind,
        kindLabel: KIND_LABELS[kind] ?? null,
        status,
        statusLabel: STATUS_LABELS[status] ?? null,
        creditState,
        creditStateLabel: CREDIT_LABELS[creditState] ?? null,
      })
    }
  }

  return appointments
}
